/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import CommonFeedbackBanner from 'ggApp/shared/common/FeedbackBanner';

export const FeedbackBanner = styled(CommonFeedbackBanner)`
    margin-bottom: ${({ theme }) => theme.spacers.L};
`;
